import type { IndexingAggregateView } from "./IndexingBadge";

export function pickIcon(aggregate: IndexingAggregateView): string {
  let icon: string;
  if (aggregate.submittedCount > 0) {
    icon = "✅";
  } else {
    if (aggregate.failedCount > 0) {
      icon = "❌";
    } else {
      if (aggregate.pendingCount === 0 && aggregate.skippedCount > 0) {
        icon = "⊘";
      } else {
        icon = "—";
      }
    }
  }
  return icon;
}
